<template>
  <div>
    <Header v-if="!logged" @request-register="$emit('request-register')" />
    <main>
      <section class="anti-slavery">
        <div class="o-container">
          <article>
            <div class="header-mob">
              <router-link :to="{name: 'search'}" class="back-mob"><svg xmlns="http://www.w3.org/2000/svg" width="14.004" height="14.001"><path data-name="Union 6" d="M6.289 13.708.262 7.669a1 1 0 0 1 .03-1.379l6-6a1 1 0 0 1 1.417 0 1 1 0 0 1 0 1.413l-4.3 4.295H13a1 1 0 0 1 1 1 1 1 0 0 1-1 1H3.41l4.292 4.3a1 1 0 0 1 0 1.412A1 1 0 0 1 7 14a1 1 0 0 1-.711-.292Z"/></svg></router-link>
              <h1>{{$t('general.anti_slavery')}}</h1>
            </div>
            <br />
            <div v-html="themeT('anti_slavery.raw')"></div>
          </article>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ThemeMixin from "@/mixins/ThemeMixin";
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";

export default {
  name: 'AntiSlavery',
  mixins: [AuthenticatedMixin, ThemeMixin],
  components: { Header },
    created() {
        this.VUE_APP_NAME = process.env.VUE_APP_NAME
    }
}
</script>

<style scoped lang="scss">

    main {
        @media (max-width: 991px) {
            // background-color: #fff;
        }
    }

    .header-mob {
        display: none;

        @media(max-width: 500px) {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            h1 {
                margin-bottom: 0!important;
                font-size: 22px!important;
                font-weight: 700!important;
            }

            .back-mob {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
                margin-right: 10px;
            }
        }
    }



    // .safety {
    //     padding: 70px 0;

    //     article {
    //         width: 100%;
    //         margin: 0 auto;
    //         max-width:680px;
    //         padding: 0 15px;

    //         @media(max-width: 500px) {
    //             padding: 0;
    //         }
    //     }

    //     .heading-mob {
    //         @media(max-width: 500px) {
    //             display: none;
    //         }
    //     }

    //     h1 {
    //         font-size: 26px;
    //         font-weight: 800;
    //         margin-bottom: 47px;
    //     }

    //     h2 {
    //         font-size: 17px;
    //         margin-top: 62px;
    //         margin-bottom: 15px;
    //     }

    //     p,
    //     li {
    //         line-height: 1.5;
    //     }

    //     ul {
    //         padding-left: 30px;
    //         list-style-type: disc;
    //         margin-bottom: 0;
    //     }

    //     li {
    //         padding: 10px 10px;
    //     }

    //     p {
    //         a {
    //             color: #bfa46a;

    //             &:hover {
    //                 text-decoration: underline;
    //             }
    //         }
    //     }

    //     @media(max-width: 991px) {
    //         padding: 20px 0 60px;

    //         h1 {
    //             font-size: 22px;
    //             margin-bottom: 20px;
    //         }

    //         h2 {
    //             margin-top: 20px;
    //         }

    //         p,li {
    //             font-size: 14px;
    //         }

    //         ul {
    //             padding-left: 15px;
    //         }

    //         li {
    //             padding: 5px 10px;
    //         }
    //     }
    // }
    .anti-slavery {
        padding: 70px 0;

        article {
            width: 100%;
            margin: 0 auto;
            max-width:650px;

        }

        @media(max-width: 500px) {
            padding: 20px 0 70px;

        }
    }
</style>

<style lang="scss">
    .anti-slavery {

        h1 {
            font-weight: 700;
            font-size: 24px;
        }

        h2 {
            margin-bottom: 15px;
            margin-top: 35px;
            font-weight: 700;

        }

        ul {
            padding-left: 30px;
            list-style-type: disc;
        }

        li {
            padding: 10px 10px;
            line-height: 1.5;

        }

        em {
            line-height: 1.5;
            font-style: italic;
            font-size: 14px;
        }

        p {
            line-height: 1.5;

            a {
                color: $color-type19;
            }
        }

        @media(max-width: 991px) {
            padding: 40px 0 70px;

            article {
                h1 {
                    margin-bottom: 20px;
                }

                br {
                    display: none;
                }
            }

            ul {
                padding-left: 15px;
            }
        }

        .heading-mob {
            @media(max-width: 500px) {
                display: none;
            }
        }
    }
</style>
